import React, {useContext} from 'react';
import {Audit} from "@bdfx/audit-api/types"
import { Div, Grid, css, Header, Icon } from "@bdfx/fukit"
import Section, {shadow} from "../homepage/section"
import { formatInt, } from "../../common/format"
import {apiRegenerateAudit} from "@bdfx/audit-api"
import ResultHeader from "../result/result-header"
import { SummaryBox, Style, getIcon } from "../result/result"
import {ERRORS, WARNINGS, SUGGESTIONS, } from "../helpers"
import Footer from "../result/footer"
import {AuditContext} from "../providers/AuditProvider"
import {ProductsContext} from "../providers/ProductsProvider"
import {Placeholder} from "../app"
import {getAuditId} from "../../common/helpers"
import {getFilters} from "../helpers"
import trans from "../trans"
import ctrans from "../../common/trans"
import PriceHistogram from "./price-histogram"
import Results from "../result/results"
import Products from "./products"
import ModalProgress from "../../common/homepage/modal-progress"
import {eventGA} from "../../common/tracking"
import PricingFoxCtaButton from '../app-components/pricingfox-cta-button';
import ExportButton from '../result/export-button';


function ResultDetail() {

    const [audit]: [Audit] = useContext(AuditContext)
    const [products]: any = useContext(ProductsContext)
    const index: string = getFilters()
    
    if(!audit || !products) {
        return <Placeholder /> 
    }
    if(index === "regenerate") {

        eventGA("AUDIT", "Audit regenerate", "AUDIT_REGENERATE")

        document.title = ctrans("regenerate_audit") + " | Pricing Audit"
        apiRegenerateAudit(audit?.id)
        return <ResultsSection>
                <div>
                    <Div maxWidth="600px !important" minHeight="100vh" margin="auto" textAlign="left">
                    <ModalProgress auditId={audit?.id} email={audit?.notify_email} />
                    </Div>
                </div>
            </ResultsSection>
    } else {
        if(index.indexOf("group_") > -1) {
            document.title = ctrans("sortiment") + " " + trans(index).toLowerCase() + " | Pricing Audit"
        } else {
            document.title = trans(index) + " | Pricing Audit"
        }
    }

    if(getAuditId() !== "example") {
        eventGA("AUDIT", "Audit result detail", "AUDIT_RESULT_DETAIL")
    }

    let errors = {}
    let warnings = {}
    let suggestions = {}

    if(index === "group_problems") {
        errors = ERRORS.reduce((acc,index) => ({...acc, [index]: audit.result?.[index]}) ,{});
    }
    if(index === "group_warnings") {
        warnings = WARNINGS.reduce((acc,index) => ({...acc, [index]: audit.result?.[index]}) ,{});
    }
    if(index === "group_recommendations") {
        suggestions = SUGGESTIONS.reduce((acc,index) => ({...acc, [index]: audit.result?.[index]}) ,{});
    }

    return (
        <Style>
            <ResultHeader data={audit} title={trans(index)} index={index}>
                <Div marginTop="40px" as={Grid} cols="auto 1fr" gap="40px">
                    <Div maxWidth="220px" className="flags">
                    <SummaryBox index={index}>
                        <span className="products-total">
                            {formatInt(audit.result?.[index])}
                        </span>
                        <br/>
                        {ctrans("n_products", {n: null})}
                        <br/>
                        <Icon color="white" size="35" type={getIcon(index)} />
                        <br/>
                        {ctrans("out_of")} {formatInt(audit.result?.total_products)}
                    </SummaryBox>
                    </Div>
                    <p>
                    {trans(index+"_info", {
                        group_ok: formatInt(audit.result?.group_ok),
                        group_problems: formatInt(audit.result?.group_problems),
                        group_warnings: formatInt(audit.result?.group_warnings),
                        group_recommendations: formatInt(audit.result?.group_recommendations),
                    })}
                    </p>
                </Div>    
                <Div marginBlock="2em -2em">
                    <PricingFoxCtaButton />
                </Div> 
            </ResultHeader>

            {index.indexOf("group_") > -1 && index !== "group_ok" ? 
                <Results auditId={audit.id} total={audit.result?.total_products} errors={errors} warnings={warnings} suggestions={suggestions} />
            : null}

            {products?.data?.price_histogram && Object.keys(products.data.price_histogram).length > 0 ? 
                <PriceHistogram total={audit.result?.[index]} locale={audit.shop?.heureka_locale} price_histogram={products?.data?.price_histogram} />
            : null }

            <ResultsSection className="content section">
                <div>
                    <Div>
                        <Div as={Header} type={2} textAlign="center">
                            {ctrans("products_found")}
                            <Div float="right">
                                <ExportButton auditId={audit.id} index={index} size="small" color="green" />
                            </Div>
                        </Div>
                        <Products />
                    </Div>
                </div>
            </ResultsSection>
                
            <Footer userEmail={audit.notify_email}/>
        </Style>
    );
}

const ResultsSection = css(Section)({
  filter: shadow,
  position: "relative",
  minHeight: "100vh",
  zIndex: 2,

  ".products img": {
    overflow: "hidden",
    maxWidth: "60px", 
    maxHeight: "60px",
  },

  "a": {
    color: "#3c3c3c",
    textDecoration: "underline",
  },

})


export default ResultDetail;
